/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Settings24({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="m19.6 9.6 2.4.4v4l-2.4.4c-.1.4-.3.9-.5 1.3l1.4 2-2.8 2.8-2-1.4c-.4.2-.8.4-1.3.5L14 22h-4l-.4-2.4c-.4-.1-.9-.3-1.3-.5l-2 1.4-2.8-2.8 1.4-2c-.2-.4-.4-.8-.5-1.3L2 14v-4l2.4-.4c.1-.4.3-.9.5-1.3l-1.4-2 2.8-2.8 2 1.4c.4-.2.9-.4 1.3-.5L10 2h4l.4 2.4c.4.1.9.3 1.3.5l2-1.4 2.8 2.8-1.4 2c.2.4.4.8.5 1.3ZM12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
